// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  background-color: #FFC61D;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem;
  height: 100%;
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.3019607843);
}
.container .text {
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
  font-size: 14px;
  max-width: 60%;
  color: #161615;
  margin-left: 0.5rem;
  align-self: center;
}
.container .text.virtual {
  max-width: 100%;
  margin: auto;
  min-height: 3rem;
  display: flex;
  align-items: center;
}
.container .wallet {
  display: flex;
  border-radius: 6px;
  background-color: #ffffff;
  align-self: center;
}
.container .wallet .balance-text {
  font-family: "Inter";
  font-size: 10px;
  font-weight: 200;
  background-color: #161615;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  color: white;
  -webkit-text-orientation: mixed;
          text-orientation: mixed;
  writing-mode: vertical-lr;
  rotate: 180deg;
  text-align: center;
  min-height: -webkit-max-content;
  min-height: -moz-max-content;
  min-height: max-content;
  padding: 0.5rem 0.2rem;
}
.container .wallet .balance {
  display: flex;
  justify-content: center;
  align-self: center;
  padding: 0rem 0.75rem;
}
.container .wallet .balance .wallet-icon {
  width: 1.5rem;
  height: 1.5rem;
}
.container .wallet .balance .currency {
  align-self: center;
}`, "",{"version":3,"sources":["webpack://./src/app/components/home/gift-coupon/gift-coupon.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;EACA,mDAAA;AACF;AACE;EACE,qCAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AACJ;AACI;EACE,eAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AACN;AAEE;EACE,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAAJ;AACI;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,4BAAA;EACA,+BAAA;EACA,YAAA;EACA,+BAAA;UAAA,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;EAAA,4BAAA;EAAA,uBAAA;EACA,sBAAA;AACN;AAEI;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;AAAN;AAEM;EACE,aAAA;EACA,cAAA;AAAR;AAEM;EACE,kBAAA;AAAR","sourcesContent":[".container {\n  background-color: #FFC61D;\n  border-radius: 12px;\n  display: flex;\n  justify-content: space-between;\n  padding: 0.5rem;\n  height: 100%;\n  box-shadow: 0px 8px 8px #0000004d;\n\n  .text {\n    font-family: \"Montserrat\", sans-serif;\n    font-weight: bold;\n    font-size: 14px;\n    max-width: 60%;\n    color: #161615;\n    margin-left: 0.5rem;\n    align-self: center;\n\n    &.virtual {\n      max-width: 100%;\n      margin: auto;\n      min-height: 3rem;\n      display: flex;\n      align-items: center;\n    }\n  }\n  .wallet {\n    display: flex;\n    border-radius: 6px;\n    background-color: #ffffff;\n    align-self: center;\n    .balance-text {\n      font-family: \"Inter\";\n      font-size: 10px;\n      font-weight: 200;\n      background-color: #161615;\n      border-top-right-radius: 6px;\n      border-bottom-right-radius: 6px;\n      color: white;\n      text-orientation: mixed;\n      writing-mode: vertical-lr;\n      rotate: 180deg;\n      text-align: center;\n      min-height: max-content;\n      padding: 0.5rem 0.2rem;\n    }\n\n    .balance {\n      display: flex;\n      justify-content: center;\n      align-self: center;\n      padding: 0rem 0.75rem;\n\n      .wallet-icon {\n        width: 1.5rem;\n        height: 1.5rem;\n      }\n      .currency {\n        align-self: center;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
